import axios from 'axios'
import qs from 'qs'

// axios 示例对象
const _instance = axios.create({
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json'
  }
})

function POST(url, params) {
  return _instance.post(url, qs.stringify(params)).then()
}

// function GET(url, params) {
//     return _instance.get(url, qs.stringify(params)).then()
// }

// -----------------------------------------------------------
// const NI_ONLINE_SERVER = 'http://alphago.chemucao.cn/'
const NI_ONLINE_SERVER = ''
const NI_ONLINE_SERVER_SUB = '/real/api/index.php'

// 查询余额接口 user/coin_get
export function loadCheckBalance(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/user/coin_get`, params).then(resp => resp.data)
}

// 用户的登录或者注册
export function loadUserLogin(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/user/login`, params).then(resp => resp.data)
}
// 用户查询小区成交的接口
export function loadCommunityNearby(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/community/nearby`, params).then(resp => resp.data)
}

// 用户查询整个城市成交的接口
export function loadCityDeal(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/city/deal`, params).then(resp => resp.data)
}

// 用户查询附件区县
export function loadCountyNearby(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/district/nearby`, params).then(resp => resp.data)
}

// 用户查询附近商圈的接口
export function loadBusinessNearby(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/bizcycle/nearby`, params).then(resp => resp.data)
}

// 用户查询整个商圈成交的接口
export function loadBusinessSearch(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/bizcycle/deal`, params).then(resp => resp.data)
}

// 用户查询小区成交的接口
export function loadCommunitySearch(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/community/deal`, params).then(resp => resp.data)
}

// 用户查询整个区成交的接口
export function loadCountySearch(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/district/deal`, params).then(resp => resp.data)
}

//  公众号用户发起支付接口
export function loadWxpayJsapi(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/wxpay/jsapi`, params).then(resp => resp.data)
}

// 用户给url签名的接口
export function loadWxConfigure(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/jsapi/sign`, params).then(resp => resp.data)
}

// 微信支付结果通知
export function loadWxPayNotify(params) {
  return POST(`${NI_ONLINE_SERVER}${NI_ONLINE_SERVER_SUB}/wxpay/notify`, params).then(resp => resp.data)
}



// WEBPACK FOOTER //
// ./src/common/fetch/Fetch.js